import { ExchangePriceBreakdown, ExchangeVariantPriceInfoFragment } from '@websky/graphql';
import { getCurrency } from '../../../../cache';

export function getCalculatedExchangePrices(prices: ExchangeVariantPriceInfoFragment | ExchangePriceBreakdown) {
	if (!prices) {
		return { total: null, charge: null, ticket: null };
	}

	const currency = prices.priceToPay?.currency || getCurrency();

	const agencyChargesForExareAmount = prices?.agencyChargesForExare?.amount || 0;
	const exchangeAirlinePenaltyAmount = prices?.exchangeAirlinePenalty?.amount || 0;

	const totalAmount = prices.priceToPay?.amount || 0;
	const chargeAmount = agencyChargesForExareAmount + exchangeAirlinePenaltyAmount;
	const ticketAmount = totalAmount - chargeAmount;

	return {
		total: { currency, amount: totalAmount },
		charge: { currency, amount: chargeAmount },
		ticket: { currency, amount: ticketAmount }
	};
}
